/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.entity', [])
    .factory('entityService', EntityService)
    .name;

/*@ngInject*/
function EntityService($q, types, providerService, providerSubscriptionService,
                       customerSubscriptionService, userService, customerService, subCustomerService, converterService,
                       deviceModelService, gatewayModelService, gatewayGroupService, applicationService, multicastGroupService) {

    var service = {
        getEntities: getEntities,
        getEntity: getEntity
    }

    return service;

    function getEntities(entityType) {
        var deferred = $q.defer();
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;

        var getEntitiesPromise;
        switch (entityType) {
            case types.entityType.provider:
                getEntitiesPromise = providerService.getProviders();
                break;
            case types.entityType.customer:
                getEntitiesPromise = customerService.getCustomers();
                break;
            case types.entityType.subCustomer:
                getEntitiesPromise = subCustomerService.getSubCustomers();
                break;
            case types.entityType.converter:
                getEntitiesPromise = converterService.getCustomerConverters();
                break;
            case types.entityType.converterV1:
                getEntitiesPromise = converterService.getCustomerConvertersV1();
                break;
            case types.entityType.converterV2:
                getEntitiesPromise = converterService.getCustomerConvertersV2();
                break;
            case types.entityType.provider_subscription:
                getEntitiesPromise = providerSubscriptionService.getProviderSubscriptions();
                break;
            case types.entityType.customer_subscription:
                getEntitiesPromise = customerSubscriptionService.getCustomerSubscriptions();
                break;
            case types.entityType.device_model:
                getEntitiesPromise = deviceModelService.getCustomerDeviceModels();
                break;
            case types.entityType.gateway_model:
                getEntitiesPromise = gatewayModelService.getProviderGatewayModels();
                break;
            case types.entityType.gateway_group:
                if (scope == types.scope.provider) {
                    getEntitiesPromise = gatewayGroupService.getProviderGatewayGroups();
                } else if (scope == types.scope.customer) {
                    getEntitiesPromise = gatewayGroupService.getCustomerGatewayGroups(currentUser.customerId);
                }
                break;
            case types.entityType.application:
                getEntitiesPromise = applicationService.getCustomerApplications(currentUser.customerId);
                break;
            case types.entityType.multicast_group:
                if (scope == types.scope.customer) {
                    getEntitiesPromise = multicastGroupService.getCustomerMulticastGroups(currentUser.customerId);
                } else if (scope == types.scope.subCustomer) {
                    getEntitiesPromise = multicastGroupService.getSubCustomerMulticastGroups(currentUser.subCustomerId);
                }
                break;
        }
        if (getEntitiesPromise) {
            getEntitiesPromise.then((entities) => {
                entityType === types.entityType.multicast_group
                    ? deferred.resolve(entities.data)
                    : deferred.resolve(entities)
            },
            () => {
                deferred.reject();
            });
        } else {
            deferred.reject();
        }

        return deferred.promise;
    }

    function getEntity(entityId) {
        var deferred = $q.defer();
        var getEntityPromise;
        switch (entityId.entityType) {
            case types.entityType.provider:
                getEntityPromise = providerService.getProvider(entityId.id);
                break;
            case types.entityType.customer:
                getEntityPromise = customerService.getCustomer(entityId.id);
                break;
            case types.entityType.subCustomer:
                getEntityPromise = subCustomerService.getSubCustomer(entityId.id);
                break;
            case types.entityType.converter:
                getEntityPromise = converterService.getConverter(entityId.id);
                break;
            case types.entityType.converterV1:
                getEntityPromise = converterService.getConverter(entityId.id);
                break;
            case types.entityType.converterV2:
                getEntityPromise = converterService.getConverter(entityId.id);
                break;
            case types.entityType.provider_subscription:
                getEntityPromise = providerSubscriptionService.getProviderSubscription(entityId.id);
                break;
            case types.entityType.customer_subscription:
                getEntityPromise = customerSubscriptionService.getCustomerSubscription(entityId.id);
                break;
            case types.entityType.device_model:
                getEntityPromise = deviceModelService.getDeviceModel(entityId.id);
                break;
            case types.entityType.gateway_model:
                getEntityPromise = gatewayModelService.getGatewayModel(entityId.id);
                break;
            case types.entityType.gateway_group:
                getEntityPromise = gatewayGroupService.getGatewayGroup(entityId.id);
                break;
        }
        if (getEntityPromise) {
            getEntityPromise.then((entity) => {
                    deferred.resolve(entity);
                },
                () => {
                    deferred.reject();
                });
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/entity.service.js